<template>
  <footer class="bb-footer">
    <div class="bb-footer-inner">
      <div class="bb-footer-grid">
        <div>
          <div class="bb-footer-brand">
            <div class="bb-footer-mark-tile">
              <img src="@/assets/img/logom.png" alt="Bandhoo" class="bb-footer-mark" />
            </div>
            <span class="bb-footer-brand-name">BANDHOO</span>
          </div>
          <p class="bb-footer-blurb">
            Solving the trickiest problems in construction using technology — across project
            monitoring, cost management, and manpower mobilization.
          </p>
          <div class="bb-footer-contacts">
            <a href="mailto:info@bandhoo.com" class="bb-footer-mail">info@bandhoo.com</a>
            <a href="tel:+916364432123" class="bb-footer-phone">Helpline: 6364-432-123</a>
            <a
              v-if="whatsapp"
              :href="whatsapp.url"
              target="_blank"
              class="bb-footer-phone"
              @click="sendInformationToGoogleAnalitics(whatsapp.gtag)">
              WhatsApp: {{ whatsapp.contactInfo }}
            </a>
          </div>
        </div>

        <div v-for="col in homeFooterCols" :key="col.title">
          <div class="bb-footer-col-title">{{ col.title }}</div>
          <div class="bb-footer-col-links">
            <RouterLink
              v-for="link in col.links"
              :key="link.name"
              :to="link.url"
              class="bb-foot-link"
              @click="sendInformationToGoogleAnalitics(link.gtag)">
              {{ link.name }}
            </RouterLink>
          </div>
        </div>
      </div>

      <div class="bb-footer-bottom">
        <span>© {{ copyrightYear }} Bandhoo Technologies. All rights reserved.</span>
        <span>bandhoo.com</span>
      </div>
    </div>
    <BandhooFloats></BandhooFloats>
  </footer>
</template>

<script>
import BandhooFloats from "@/components/Floats.vue"
import { homeFooterCols } from '@/assets/db/home-data'
import { bandhooContacts } from '@/assets/db/static-data'
import { GoogleAdsConversions } from '@/assets/db/config'

export default {
  name: 'SiteFooter',
  components: { BandhooFloats },
  data() {
    return {
      homeFooterCols
    }
  },
  computed: {
    copyrightYear() {
      return new Date().getFullYear();
    },
    whatsapp() {
      return bandhooContacts.find(contact => contact.gtag === 'website_whatsapp')
    }
  },
  methods: {
    sendInformationToGoogleAnalitics(information) {
      if (!information) {
        return
      }
      if (information === 'website_whatsapp') {
        this.$gtag.event('conversion', GoogleAdsConversions.WEBSITE_WHATSAPP);
      }
      this.$gtag.event(information);
    }
  }
}
</script>

<style scoped>
.bb-footer {
  background: var(--bb-navy-deep);
  color: #fff;
  padding: 64px 24px 32px;
}

.bb-footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.bb-footer-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 44px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.bb-footer-brand {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 16px;
}

.bb-footer-mark-tile {
  width: 40px;
  height: 40px;
  border-radius: 9px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bb-footer-mark {
  display: block;
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.bb-footer-brand-name {
  font-weight: 900;
  font-size: 20px;
  letter-spacing: 2px;
}

.bb-footer-blurb {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13.5px;
  line-height: 1.7;
  max-width: 300px;
}

.bb-footer-contacts {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: flex-start;
}

.bb-footer-mail {
  color: var(--bb-lime);
  font-size: 13.5px;
  font-weight: 600;
}

.bb-footer-phone {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13.5px;
}

.bb-footer-col-title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.42);
  margin-bottom: 16px;
}

.bb-footer-col-links {
  display: flex;
  flex-direction: column;
  gap: 11px;
  align-items: flex-start;
}

.bb-foot-link {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13.5px;
  transition: color 0.2s;
}

.bb-foot-link:hover {
  color: var(--bb-lime);
}

.bb-footer-bottom {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12.5px;
}

@media (max-width: 720px) {
  .bb-footer-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 460px) {
  .bb-footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>
